<template>
  <div class="tile-grid-item" :class="modifierClassnames">
    <slot />
  </div>
</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
  type: {
    type: String,
    default: "default",
  },
});

const modifierClassnames = computed(() => ({
  [`--type-${props.type}`]: true,
}));
</script>
<style lang="scss" scoped>
.tile-grid-item {
  --content-padding: var(--sp-dtv-tile-grid-item-padding, 0.75rem);
  display: flex;
  padding: var(--content-padding);
  border: var(--sp-dtv-tile-grid-item-border-width, 1px) var(--sp-dtv-tile-grid-item-border-style, solid)
    var(--sp-dtv-tile-grid-item-border-color, var(--sp-sys-color-primary, #00818a));
  border-radius: var(--sp-dtv-tile-grid-item-border-radius, var(--sp-sys-form-field-border-radius, 0));
  min-height: var(--sp-dtv-tile-grid-item-min-height, 2rem);

  &.--type-radio {
    padding: 0;
    --sp-dtv-radio-btn-padding-inline: var(--content-padding);
  }
}
</style>
